import { NotificationManager } from 'react-notifications';
import axios from 'axios';
import moment from 'moment';
import database from '../../system/model/firebase/firebase';
import { backendTypes, Post_Multi_Candidate } from './applicantActions';
import { bodyMailNotification } from '../../system/helpers/main';

// TODO Todo referente a Email's
// GET
export const Email_Comapny = (payload) => ({
  type: backendTypes.Email_Format,
  payload,
});
export const Load_Email_Format = () => {
  return (dispatch, getState) => {
    const { uid } = getState().auth;
    const { platform } = getState();
    const ArrayTemp = [];
    database
      .collection(platform.platformName)
      .doc(`data`)
      .collection('companies')
      .doc(uid)
      .collection('Format_Email')
      .get()
      .then((e) => {
        Object.values(e.docs).map((o) => {
          const temp = o.data();
          ArrayTemp.push(temp);
        });
        dispatch(Email_Comapny(ArrayTemp));
      });
  };
};

export const getActivity = (data = {}) => {
  return (dispatch, getState) => {
    const { platform } = getState();
    database
      .collection(`${platform.platformName}/data/companies`)
      .doc(data.uid)
      .collection('jobs')
      .doc(data.id)
      .collection('activity')
      .get()
      .then((e) => {
        const { docs } = e;
        const Array_Temp = [];
        docs.map((o) => {
          Array_Temp.push({
            ...o.data(),
            docID_activity: o.id,
          });
        });
        dispatch({
          type: backendTypes.getActivity,
          activity: Array_Temp,
        });
      });
  };
};

// Metodos obtenidos de vesiones anteriores
export const addColumn = ({ uid, url, columns, doc, boxes, prevDocument }) => {
  return async (dispatch, getState) => {
    const { platform } = getState();
    await dispatch({
      type: backendTypes.Load,
      load: true,
    });
    // let index_Inicial = columns[columns - 2]?.index;
    const removed = columns.splice(columns.length - 2, 2);
    await database
      .collection(`${platform.platformName}/data/companies`)
      .doc(uid)
      .collection('jobs')
      .doc(url)
      .collection('vacation_column')
      .add({
        name: 'Sin Nombre',
        index: columns.length,
      })
      .then((e) => {
        // console.log(e)
        columns.push(
          {
            name: 'Sin Nombre',
            docID: e.id,
          },
          ...removed
        );
        columns.map((e, index) => {
          e.index = +index;
        });
        dispatch({
          type: backendTypes.Drag_Candidate,
          column: columns,
        });
        removed.map((o) => {
          database
            .collection(`${platform.platformName}/data/companies`)
            .doc(uid)
            .collection('jobs')
            .doc(url)
            .collection('vacation_column')
            .doc(o.docID)
            .update({ index: o.index });
        });
      });
  };
};

export const deleteColumn = ({ uid, url, key }) => {
  return async (dispatch, getState) => {
    const data = Object.values(getState().backend?.vacancy?.column);
    const { platform } = getState();
    const candidates_Store = getState().backend?.vacancy?.candidates_Store;
    await dispatch({
      type: backendTypes.Load,
      load: true,
    });
    const array_new_candidate = getState().backend?.vacancy?.candidates;

    const findColum = data.find((e) => e.docID == key);
    // console.log(findColum)
    if (findColum.candidates) {
      if (findColum.candidates.length > 0) {
        findColum.candidates.map((o) => {
          array_new_candidate.push(candidates_Store.find((p) => o.idUser === p.docID));
        });
      }
    }
    // console.log(array_new_candidate)
    database
      .collection(`${platform.platformName}/data/companies`)
      .doc(uid)
      .collection('jobs')
      .doc(url)
      .collection('vacation_column')
      .doc(key)
      .delete()
      .then(() => {
        NotificationManager.success('Columna eliminada');
        const temp_Array = data.filter((e) => e.docID !== key);

        temp_Array.map((o, index) => {
          o.index = index;
          database
            .collection(`${platform.platformName}/data/companies`)
            .doc(uid)
            .collection('jobs')
            .doc(url)
            .collection('vacation_column')
            .doc(o.docID)
            .update({ index });
        });

        dispatch({
          type: backendTypes.Drag_Candidate_Organic,
          column: temp_Array,
          candidates: array_new_candidate,
        });
      })
      .catch((e) => {
        NotificationManager.error('Ocurrió un error en el servidor.');
      });
  };
};

export const updateNameColumn = ({ uid, url, data, name }) => {
  return (dispatch, getState) => {
    const { platform } = getState();
    dispatch({
      type: backendTypes.Load,
      load: true,
    });
    if (name !== '') {
      database
        .collection(`${platform.platformName}/data/companies`)
        .doc(uid)
        .collection('jobs')
        .doc(url)
        .collection('vacation_column')
        .doc(data)
        .update({
          name,
        })
        .then((e) => {
          const names = Object.values(getState().backend?.vacancy?.column).map((e) => {
            if (e.docID === data) {
              e.name = name;
            }
            return e;
          });
          dispatch({
            type: backendTypes.VACANCY,
            id: data,
            column: names,
          });
        });
    } else {
      NotificationManager.error(`El nombne de una columna no puede ser vacio`, '', 3000);
    }
  };
};

export const action_Drag_Candidate_Organic = ({ candidate, columns }) => {
  return async (dispatch, getState) => {
    await dispatch({
      type: backendTypes.Load,
      load: true,
    });
    await dispatch({
      type: backendTypes.Drag_Candidate_Organic,
      candidates: candidate,
      column: columns,
    });
  };
};

export const ac_Drag_column_firebaser = ({ uid, vacancy }, array_columns) => {
  return (dispatch, getState) => {
    const { platform } = getState();
    array_columns.map((o) => {
      if (o.candidates) {
        database
          .collection(`${platform.platformName}/data/companies`)
          .doc(uid)
          .collection('jobs')
          .doc(vacancy)
          .collection('vacation_column')
          .doc(o.docID)
          .update({ candidates: o.candidates });
      }
    });
  };
};

export const Send_Email = (data = {}) => {
  return () => {
    axios
      .request({
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
        url: 'https://us-central1-universia-prod.cloudfunctions.net/SendEmail_HTML',
        method: 'POST',
        data,
        crossDomain: true,
      })
      .then(() => {
        NotificationManager.success('Correo Enviado', '', 3000);
      })
      .catch((e) => {
        console.error(e);
      });
  };
};

/// TODO Activity

export const sendActivity = (data = {}, candidate) => {
  return (dispatch, getState) => {
    const Array_activity = getState().backend?.vacancy?.activity?.slice();
    const columns = getState().backend?.vacancy?.column.slice();
    const EmailFormat = getState().backend.Email_Format ? getState().backend.Email_Format : [];
    const Users = getState().backend?.vacancy?.candidates_Store;
    const { company } = getState();
    const { vacancies } = getState();
    const { platform } = getState();
    const { type, to, from, candidate, vacancy } = data;

    Array_activity.push(data);
    dispatch({
      type: backendTypes.getActivity,
      activity: Array_activity,
    });
    // TODO Enviar correo de notificación de processo solo si,
    // es la primera vez que sale de la primera columna
    let toColumn = null;
    let fromcolumn = null;
    if (type === 'drag') {
      toColumn = to !== 'canidates' ? Object.values(columns).find((column) => column.docID === to) : 'canidates';

      fromcolumn = from !== 'canidates' ? Object.values(columns).find((column) => column.docID === from) : 'canidates';

      const user = Object.values(Users).find((e) => e.docID === candidate);
      const Find_vacancy = Object.values(vacancies).find((o) => o.jobID === vacancy);
      if (toColumn.name === 'Rechazados') {
        const ArrayActivityPer = Array_activity.filter((e) => e.candidate === candidate).filter(
          (e) => e.from === toColumn.docID
        );
        // console.log(ArrayActivityPer.length)
        if (user.docID) {
          database
            .collection(`${platform.platformName}/data/companies`)
            .doc(data.id_company)
            .collection('applicantsBase')
            .doc(user.docID)
            .update({
              ColumnStatus: 'Rechazados',
            });
          database
            .collection(platform.platformName)
            .doc('data')
            .collection('users')
            .doc(user.candidateID)
            .collection('history')
            .doc(user.jobID)
            .update({
              process: 'Rechazado',
            });
        }
        if (ArrayActivityPer.length < 1) {
          // console.log('entro',EmailFormat.length)

          if (EmailFormat.length > 0) {
            const { logoMain, body, subject } = Object.values(EmailFormat).find((e) => e.ObjectId == 'EmailRe');
            dispatch(
              Send_Email(
                bodyMailNotification(logoMain, body, user.email, subject, {
                  COMPANY: company.companyName,
                  VACANCY: Find_vacancy.jobTitle,
                  CANDIDATE: user.names,
                })
              )
            );
          } else {
            dispatch(
              Send_Email({
                ...PrincipalesEmail(
                  0,
                  {
                    COMPANY: company.companyName,
                    VACANCY: Find_vacancy.jobTitle,
                    CANDIDATE: user.names,
                  },
                  platform
                ),
                destiny: user.email,
              })
            );
          }
        }
      } else if (toColumn.name === 'Aceptado(s)') {
        const ArrayActivityAc = Array_activity.filter((e) => e.candidate === candidate).filter(
          (e) => e.from === toColumn.docID
        );
        if (user.docID) {
          database
            .collection(`${platform.platformName}/data/companies`)
            .doc(data.id_company)
            .collection('applicantsBase')
            .doc(user.docID)
            .update({
              ColumnStatus: 'Aceptado(s)',
            });
          database
            .collection(platform.platformName)
            .doc('data')
            .collection('users')
            .doc(user.candidateID)
            .collection('history')
            .doc(user.jobID)
            .update({
              process: 'Aceptado',
            });
        }
        if (ArrayActivityAc.length < 1) {
          if (EmailFormat.length > 0) {
            const { logoMain, body, subject } = Object.values(EmailFormat).find((e) => e.ObjectId == 'EmailAc');
            dispatch(
              Send_Email(
                bodyMailNotification(logoMain, body, user.email, subject, {
                  COMPANY: company.companyName,
                  VACANCY: Find_vacancy.jobTitle,
                  CANDIDATE: user.names,
                })
              )
            );
          } else {
            dispatch(
              Send_Email({
                ...PrincipalesEmail(
                  2,
                  {
                    COMPANY: company.companyName,
                    VACANCY: Find_vacancy.jobTitle,
                    CANDIDATE: user.names,
                  },
                  platform
                ),
                destiny: user.email,
              })
            );
          }
        }
      } else if (to === 'canidates' || from === 'canidates') {
        if (to === 'canidates') {
          toColumn = 'Inicio';
          fromcolumn = Object.values(columns).find((column) => column.docID === from);
        }
        if (from === 'canidates') {
          fromcolumn = 'Inicio';
          toColumn = Object.values(columns).find((column) => column.docID === to);

          const user = Object.values(Users).find((e) => e.docID === candidate);
          const ArrayActivityPr = Array_activity.filter((e) => e.candidate === candidate).filter(
            (e) => e.from === toColumn.docID
          );
          if (user.docID) {
            database
              .collection(`${platform.platformName}/data/companies`)
              .doc(data.id_company)
              .collection('applicantsBase')
              .doc(user.docID)
              .update({
                ColumnStatus: 'En Proceso',
              });
            database
              .collection(platform.platformName)
              .doc('data')
              .collection('users')
              .doc(user.candidateID)
              .collection('history')
              .doc(user.jobID)
              .update({
                process: 'En Proceso',
              });
          }
          if (ArrayActivityPr.length < 1) {
            if (EmailFormat.length > 0) {
              const { logoMain, body, subject } = Object.values(EmailFormat).find((e) => e.ObjectId == 'EmailPr');
              dispatch(
                Send_Email(
                  bodyMailNotification(logoMain, body, user.email, subject, {
                    COMPANY: company.companyName,
                    VACANCY: Find_vacancy.jobTitle,
                    CANDIDATE: user.names,
                  })
                )
              );
            } else {
              dispatch(
                Send_Email({
                  ...PrincipalesEmail(
                    1,
                    {
                      COMPANY: company.companyName,
                      VACANCY: Find_vacancy.jobTitle,
                      CANDIDATE: user.names,
                    },
                    platform
                  ),
                  destiny: user.email,
                })
              );
            }
          }
        }
      } else if (user.docID) {
        database
          .collection(`${platform.platformName}/data/companies`)
          .doc(data.id_company)
          .collection('applicantsBase')
          .doc(user.docID)
          .update({
            ColumnStatus: 'En Proceso',
          });
        database
          .collection(platform.platformName)
          .doc('data')
          .collection('users')
          .doc(user.candidateID)
          .collection('history')
          .doc(user.jobID)
          .update({
            process: 'En proceso',
          });
      }
    }
    database
      .collection(`${platform.platformName}/data/companies`)
      .doc(data.id_company)
      .collection('jobs')
      .doc(data.vacancy)
      .collection('activity')
      .add(data)
      .then(() => {
        Array_activity.push(data);
        dispatch({
          type: backendTypes.getActivity,
          activity: Array_activity,
        });
      });
  };
};

export const action_Drag_Candidate = ({ columns }) => {
  return async (dispatch, getState) => {
    await dispatch({
      type: backendTypes.Load,
      load: true,
    });
    await dispatch({
      type: backendTypes.Drag_Candidate,
      column: columns,
    });
  };
};

export const PrincipalesEmail = (value = 0, changeValues, platform) => {
  switch (value) {
    case 0:
      return platform.customEmails
        ? {
            fromEmail: `${platform.fromEmail}`,
            subject: Format_Text_Email('{CANDIDATE} tenemos noticias sobre tu proceso para {VACANCY}', changeValues),
            ObjectId: 'EmailRe',
            body: Format_Text_Email(
              '  <p>Hola&nbsp; <em>{CANDIDATE}, </em>¿Cómo estás?</p><p><br></p><p><br></p><p>Quiero agradecerte el tiempo y la dedicación que mostraste en el proceso para la vacante de <em>{VACANCY}. </em>Valoro la disposición que tuviste con nosotros.</p>' +
                '<p>En esta ocasión <em>{COMPANY}</em>, ha decidido ir por otro camino. Si tienes alguna duda o quieres conocer el feedback de tu proceso responde este mail y te ' +
                'la haremos llegar.</p><p>&nbsp;</p><p class="ql-align-center">En <em>lapieza.io</em> buscamos encontrar el match perfecto de habilidades, conocimientos y ' +
                'fit-cultura entre postulantes y compañías.&nbsp; </p>' +
                `<img width='20%' src="${platform.customEmailsLogo}"/><br/><p style='font-size: 14px;'>¿Ya nos sigues?</p> <br/>` +
                `${
                  platform.facebookLink &&
                  `<a styles="margin: 7px" href=${platform.facebookLink}>
                      <img styles="margin: 8px" width="40px" src="https://cdn.iconscout.com/icon/free/png-512/facebook-logo-2019-1597680-1350125.png"/>
                    </a>`
                }
          ${
            platform.twitterLink &&
            `<a styles="margin: 7px" href=${platform.twitterLink}>
                      <img styles="margin: 8px" width="40px" src="https://cdn.icon-icons.com/icons2/1183/PNG/512/1490133460-social-icons01_82210.png"/>
                    </a>`
          }
         ${
           platform.instagramLink &&
           `<a styles="margin: 7px" href=${platform.instagramLink}>
                       <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png"/>
                    </a>`
         }
          ${
            platform.linkedinLink &&
            `<a styles="margin: 7px" href=${platform.linkedinLink}>
                      <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137382/isolated/preview/c59b2807ea44f0d70f41ca73c61d281d-icono-de-linkedin-logo-by-vexels.png"/>
                  </a>`
          }`,
              changeValues
            ),
            logoMain:
              'http://cdn.mcauto-images-production.sendgrid.net/94458846b6b3ac58/aa65677f-e39e-4b1f-b2c4-89581f00cfa1/1389x362.png',
          }
        : {
            subject: Format_Text_Email('{CANDIDATE} tenemos noticias sobre tu proceso para {VACANCY}', changeValues),
            ObjectId: 'EmailRe',
            body: Format_Text_Email(
              '  <p>Hola&nbsp; <em>{CANDIDATE}, </em>¿Cómo estás?</p><p><br></p><p><br></p><p>Quiero agradecerte el tiempo y la dedicación que mostraste en el proceso para la vacante de <em>{VACANCY}. </em>Valoro la disposición que tuviste con nosotros.</p>' +
                '<p>En esta ocasión <em>{COMPANY}</em>, ha decidido ir por otro camino. Si tienes alguna duda o quieres conocer el feedback de tu proceso responde este mail y te ' +
                'la haremos llegar.</p><p>&nbsp;</p><p class="ql-align-center">En <em>lapieza.io</em> buscamos encontrar el match perfecto de habilidades, conocimientos y ' +
                'fit-cultura entre postulantes y compañías.&nbsp; </p>' +
                "<img width='20%' src='https://firebasestorage.googleapis.com/v0/b/universia-prod.appspot.com/o/defaultImages%2Flogo-dark.37c08620.png?alt=media&token=b1c8657c-4e50-404f-8736-ae15aa0bdd29'/><br/><p style='font-size: 14px;'>¿Ya nos sigues?</p> <br/>" +
                " <a styles='margin: 7px' href='https://www.facebook.com/lapieza.io/'><img styles='margin: 8px' width='40px'" +
                "src='https://cdn.iconscout.com/icon/free/png-512/facebook-logo-2019-1597680-1350125.png'> </a><a styles='margin: 7px' href='https://twitter.com/lapiezaio?lang=es'>" +
                "<img styles='margin: 8px' width='40px' src='https://cdn.icon-icons.com/icons2/1183/PNG/512/1490133460-social-icons01_82210.png'> </a> <a styles='margin: 7px'" +
                " href='https://www.instagram.com/lapieza.io/'> <img styles='margin: 8px' width='40px'" +
                "  src='https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png'> </a>" +
                "<a styles='margin: 7px' href='https://ar.linkedin.com/company/lapieza'> <img styles='margin: 8px'width='40px'" +
                "   src='https://images.vexels.com/media/users/3/137382/isolated/preview/c59b2807ea44f0d70f41ca73c61d281d-icono-de-linkedin-logo-by-vexels.png'>" +
                '  </a>',
              changeValues
            ),
            logoMain:
              'http://cdn.mcauto-images-production.sendgrid.net/94458846b6b3ac58/aa65677f-e39e-4b1f-b2c4-89581f00cfa1/1389x362.png',
          };
    case 1:
      return platform.customEmails
        ? {
            fromEmail: `${platform.fromEmail}`,
            subject: Format_Text_Email(
              '{CANDIDATE} ¿Quieres saber cómo va tu proceso de selección para {VACANCY}?',
              changeValues
            ),
            ObjectId: 'EmailPr',
            body: Format_Text_Email(
              '  <p>Hola&nbsp;<em>{CANDIDATE}, </em>¿Cómo estás?</p>' +
                '<p><br></p><p>Sabemos que has invertido tiempo y dedicación para la vacante de <em>{VACANCY}. </em>Valoro la disposición que has tenido.Seguimos en el proceso de ' +
                'selección y tu perfil aún sigue activo, en los siguientes días recibirás más noticias.&nbsp;</p>' +
                `<img width='20%' src="${platform.customEmailsLogo}"/><br/><p style='font-size: 14px;'>¿Ya nos sigues?</p> <br/>` +
                `${
                  platform.facebookLink &&
                  `<a styles="margin: 7px" href=${platform.facebookLink}>
                      <img styles="margin: 8px" width="40px" src="https://cdn.iconscout.com/icon/free/png-512/facebook-logo-2019-1597680-1350125.png"/>
                    </a>`
                }
          ${
            platform.twitterLink &&
            `<a styles="margin: 7px" href=${platform.twitterLink}>
                      <img styles="margin: 8px" width="40px" src="https://cdn.icon-icons.com/icons2/1183/PNG/512/1490133460-social-icons01_82210.png"/>
                    </a>`
          }
         ${
           platform.instagramLink &&
           `<a styles="margin: 7px" href=${platform.instagramLink}>
                       <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png"/>
                    </a>`
         }
          ${
            platform.linkedinLink &&
            `<a styles="margin: 7px" href=${platform.linkedinLink}>
                      <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137382/isolated/preview/c59b2807ea44f0d70f41ca73c61d281d-icono-de-linkedin-logo-by-vexels.png"/>
                  </a>`
          }`,
              changeValues
            ),
            logoMain:
              'http://cdn.mcauto-images-production.sendgrid.net/94458846b6b3ac58/aa65677f-e39e-4b1f-b2c4-89581f00cfa1/1389x362.png',
          }
        : {
            subject: Format_Text_Email(
              '{CANDIDATE} ¿Quieres saber cómo va tu proceso de selección para {VACANCY}?',
              changeValues
            ),
            ObjectId: 'EmailPr',
            body: Format_Text_Email(
              '  <p>Hola&nbsp;<em>{CANDIDATE}, </em>¿Cómo estás?</p>' +
                '<p><br></p><p>Sabemos que has invertido tiempo y dedicación para la vacante de <em>{VACANCY}. </em>Valoro la disposición que has tenido.Seguimos en el proceso de ' +
                'selección y tu perfil aún sigue activo, en los siguientes días recibirás más noticias.&nbsp;</p>' +
                "<img width='20%' src='https://firebasestorage.googleapis.com/v0/b/universia-prod.appspot.com/o/defaultImages%2Flogo-dark.37c08620.png?alt=media&token=b1c8657c-4e50-404f-8736-ae15aa0bdd29'/><br/><p style='font-size: 14px;'>¿Ya nos sigues?</p> <br/>" +
                " <a styles='margin: 7px' href='https://www.facebook.com/lapieza.io/'><img styles='margin: 8px' width='40px'" +
                "src='https://cdn.iconscout.com/icon/free/png-512/facebook-logo-2019-1597680-1350125.png'> </a><a styles='margin: 7px' href='https://twitter.com/lapiezaio?lang=es'>" +
                "<img styles='margin: 8px' width='40px' src='https://cdn.icon-icons.com/icons2/1183/PNG/512/1490133460-social-icons01_82210.png'> </a> <a styles='margin: 7px'" +
                " href='https://www.instagram.com/lapieza.io/'> <img styles='margin: 8px' width='40px'" +
                "  src='https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png'> </a>" +
                "<a styles='margin: 7px' href='https://ar.linkedin.com/company/lapieza'> <img styles='margin: 8px'width='40px'" +
                "   src='https://images.vexels.com/media/users/3/137382/isolated/preview/c59b2807ea44f0d70f41ca73c61d281d-icono-de-linkedin-logo-by-vexels.png'>" +
                '  </a>',
              changeValues
            ),
            logoMain:
              'http://cdn.mcauto-images-production.sendgrid.net/94458846b6b3ac58/aa65677f-e39e-4b1f-b2c4-89581f00cfa1/1389x362.png',
          };
    case 2:
      return platform.customEmails
        ? {
            fromEmail: `${platform.fromEmail}`,
            subject: Format_Text_Email(
              '{CANDIDATE}  tenemos buenas noticias sobre tu aplicación para {COMPANY} /{VACANCY}',
              changeValues
            ),
            ObjectId: 'EmailAc',
            body: Format_Text_Email(
              '  <p>Hola&nbsp; <em>{CANDIDATE}, </em>¿Cómo estás?</p>' +
                '<p><br></p><p>Quiero agradecerte el tiempo y la dedicación que mostraste en el proceso para la vacante de <em>{VACANCY}. ' +
                '</em>Valoro la disposición que tuviste con nosotros.</p><p>&nbsp;</p><p>Todo este esfuerzo se ha visto reflejado y me da gusto contarte que has sido aceptado, ' +
                'me pondré en contacto en el transcurso de la semana para darte más información.</p><p>&nbsp;</p><p>No dudes en contactarme si tienes alguna duda o comentario.</p>' +
                '<p>&nbsp;</p><p>¡Felicidades y te deseo mucho éxito!</p><p>Nos vemos pronto</p><p><br></p>' +
                `<img width='20%' src="${platform.customEmailsLogo}"/><br/><p style='font-size: 14px;'>¿Ya nos sigues?</p> <br/>` +
                `${
                  platform.facebookLink &&
                  `<a styles="margin: 7px" href=${platform.facebookLink}>
                      <img styles="margin: 8px" width="40px" src="https://cdn.iconscout.com/icon/free/png-512/facebook-logo-2019-1597680-1350125.png"/>
                    </a>`
                }
          ${
            platform.twitterLink &&
            `<a styles="margin: 7px" href=${platform.twitterLink}>
                      <img styles="margin: 8px" width="40px" src="https://cdn.icon-icons.com/icons2/1183/PNG/512/1490133460-social-icons01_82210.png"/>
                    </a>`
          }
         ${
           platform.instagramLink &&
           `<a styles="margin: 7px" href=${platform.instagramLink}>
                       <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png"/>
                    </a>`
         }
          ${
            platform.linkedinLink &&
            `<a styles="margin: 7px" href=${platform.linkedinLink}>
                      <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137382/isolated/preview/c59b2807ea44f0d70f41ca73c61d281d-icono-de-linkedin-logo-by-vexels.png"/>
                  </a>`
          }`,
              changeValues
            ),
            logoMain:
              'http://cdn.mcauto-images-production.sendgrid.net/94458846b6b3ac58/aa65677f-e39e-4b1f-b2c4-89581f00cfa1/1389x362.png',
          }
        : {
            subject: Format_Text_Email(
              '{CANDIDATE}  tenemos buenas noticias sobre tu aplicación para {COMPANY} /{VACANCY}',
              changeValues
            ),
            ObjectId: 'EmailAc',
            body: Format_Text_Email(
              '  <p>Hola&nbsp; <em>{CANDIDATE}, </em>¿Cómo estás?</p>' +
                '<p><br></p><p>Quiero agradecerte el tiempo y la dedicación que mostraste en el proceso para la vacante de <em>{VACANCY}. ' +
                '</em>Valoro la disposición que tuviste con nosotros.</p><p>&nbsp;</p><p>Todo este esfuerzo se ha visto reflejado y me da gusto contarte que has sido aceptado, ' +
                'me pondré en contacto en el transcurso de la semana para darte más información.</p><p>&nbsp;</p><p>No dudes en contactarme si tienes alguna duda o comentario.</p>' +
                '<p>&nbsp;</p><p>¡Felicidades y te deseo mucho éxito!</p><p>Nos vemos pronto</p><p><br></p>' +
                "<img width='20%' src='https://firebasestorage.googleapis.com/v0/b/universia-prod.appspot.com/o/defaultImages%2Flogo-dark.37c08620.png?alt=media&token=b1c8657c-4e50-404f-8736-ae15aa0bdd29'/><br/><p style='font-size: 14px;'>¿Ya nos sigues?</p> <br/>" +
                " <a styles='margin: 7px' href='https://www.facebook.com/lapieza.io/'><img styles='margin: 8px' width='40px'" +
                "src='https://cdn.iconscout.com/icon/free/png-512/facebook-logo-2019-1597680-1350125.png'> </a><a styles='margin: 7px' href='https://twitter.com/lapiezaio?lang=es'>" +
                "<img styles='margin: 8px' width='40px' src='https://cdn.icon-icons.com/icons2/1183/PNG/512/1490133460-social-icons01_82210.png'> </a> <a styles='margin: 7px'" +
                " href='https://www.instagram.com/lapieza.io/'> <img styles='margin: 8px' width='40px'" +
                "  src='https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png'> </a>" +
                "<a styles='margin: 7px' href='https://ar.linkedin.com/company/lapieza'> <img styles='margin: 8px'width='40px'" +
                "   src='https://images.vexels.com/media/users/3/137382/isolated/preview/c59b2807ea44f0d70f41ca73c61d281d-icono-de-linkedin-logo-by-vexels.png'>" +
                '  </a>',
              changeValues
            ),
            logoMain:
              'http://cdn.mcauto-images-production.sendgrid.net/94458846b6b3ac58/aa65677f-e39e-4b1f-b2c4-89581f00cfa1/1389x362.png',
          };
  }
};

export const Format_Text_Email = (
  body = '',
  Change = {
    COMPANY: 'Company',
    VACANCY: 'Name vacancy',
    CANDIDATE: 'Carlos Antonio',
  },
  styleChange = [
    {
      key: 'class="ql-align-center"',
      change: 'style="text-align: center !important"',
    },
    {
      key: 'class="ql-align-justify"',
      change: 'style="text-align: justify !important"',
    },
    {
      key: 'class="ql-align-right"',
      change: 'style="text-align: right !important"',
    },
  ]
) => {
  let text = body;
  Object.keys(Change).map((e) => {
    const regex = new RegExp(`{${e}}`, 'gi');
    text = text.replace(regex, Change[e]);
  });
  Object.values(styleChange).map((e) => {
    const regex = new RegExp(`${e.key}`, 'gi');
    text = text.replace(regex, e.change);
  });

  return text;
};

// TODO AtsJsx DRAG
export const DragColumn = ({ vacancy, to, from }, column_names) => {
  return async (dispatch, getState) => {
    const { uid } = getState().auth;
    const { platform } = getState();
    const _parsedFetch = getState().backend?.vacancy?.column;
    // Se agrego el AWAIT por que al momento de quitarlo, el cambio del valor Load no es identificado por
    // el componentDidUpdate
    await dispatch({
      type: backendTypes.Load,
      load: true,
    });
    //
    const FromTemp = JSON.parse(JSON.stringify(from));
    const toTemp = JSON.parse(JSON.stringify(to));
    if (from.index > to.index) {
      // los que van despues
      const Arraytemp = column_names;

      Arraytemp.map((o) => {
        if (o.index >= toTemp.index && o.index < FromTemp.index) {
          o.index += 1;
          database
            .collection(`${platform.platformName}/data/companies`)
            .doc(uid)
            .collection('jobs')
            .doc(vacancy)
            .collection('vacation_column')
            .doc(o.docID)
            .update({ index: o.index });
        } else if (o.index === FromTemp.index) {
          o.index = toTemp.index;
          database
            .collection(`${platform.platformName}/data/companies`)
            .doc(uid)
            .collection('jobs')
            .doc(vacancy)
            .collection('vacation_column')
            .doc(o.docID)
            .update({ index: toTemp.index });
        }
      });
      Arraytemp.sort((a, b) => a.index - b.index);
      const parsedFetch = [];
      Arraytemp.map((e) => {
        parsedFetch.push(_parsedFetch.find((u) => u.docID === e.docID));
      });
      await dispatch({
        type: backendTypes.VACANCY,
        column: parsedFetch.sort((a, b) => a.index - b.index),
      });
      // dispatch({
      //     type: backendTypes.GET_COLUMN_NAMES,
      //     names: Arraytemp,
      //     parsedFetch
      // })
    } else {
      // Los que van antes
      const Arraytemp = column_names;
      Arraytemp.map((o) => {
        if (o.index <= toTemp.index && o.index > FromTemp.index) {
          o.index -= 1;
          database
            .collection(`${platform.platformName}/data/companies`)
            .doc(uid)
            .collection('jobs')
            .doc(vacancy)
            .collection('vacation_column')
            .doc(o.docID)
            .update({ index: o.index });
        } else if (o.index === FromTemp.index) {
          o.index = toTemp.index;
          // console.log(uid,vacancy,o.docID,o)
          database
            .collection(`${platform.platformName}/data/companies`)
            .doc(uid)
            .collection('jobs')
            .doc(vacancy)
            .collection('vacation_column')
            .doc(o.docID)
            .update({ index: toTemp.index });
        }
      });
      Arraytemp.sort((a, b) => a.index - b.index);
      const parsedFetch = [];
      Arraytemp.map((e) => {
        parsedFetch.push(_parsedFetch.find((u) => u.docID === e.docID));
      });
      await dispatch({
        type: backendTypes.VACANCY,
        column: parsedFetch.sort((a, b) => a.index - b.index),
      });
      // dispatch({
      //     type: backendTypes.GET_COLUMN_NAMES,
      //     names: Arraytemp,
      //     parsedFetch
      // })
    }
  };
};

// TODO MultiSelect
export const setColumn_Check_Candidate = (boolean = false) => {
  return async (dispatch, getState) => {
    await dispatch({
      type: backendTypes.Load,
      load: true,
    });
    const parsedFetch = JSON.parse(JSON.stringify(getState().backend?.vacancy?.column));
    parsedFetch.map((e) => {
      e.check_multi = false;
    });
    await dispatch({
      type: backendTypes.Column_CHECK_Candidate,
      check_C: boolean,
    });
    // await dispatch({
    //     type: backendTypes.parsedFetch_Extra,
    //     parsedFetch: parsedFetch
    // })

    await dispatch(Post_Multi_Candidate([]));
  };
};
export const deleteColumn_Check = () => {
  return async (dispatch, getState) => {
    await dispatch({
      type: backendTypes.Load,
      load: true,
    });
    const parsedFetch = JSON.parse(JSON.stringify(getState().backend?.vacancy?.column));
    parsedFetch.map((e) => {
      e.check_multi = false;
    });
    await dispatch({
      type: backendTypes.Drag_Candidate,
      column: parsedFetch,
    });
    await dispatch(Post_Multi_Candidate([]));
  };
};

export const setColumn_Check = (id) => {
  return async (dispatch, getState) => {
    await dispatch({
      type: backendTypes.Load,
      load: true,
    });
    const parsedFetch = JSON.parse(JSON.stringify(getState().backend?.vacancy?.column));
    parsedFetch.map((e) => {
      e.check_multi = false;
    });
    const change = parsedFetch.find((item) => item.docID === id);
    change.check_multi = true; // console.log(parsedFetch)
    await dispatch({
      type: backendTypes.Column_CHECK_Candidate,
      check_C: false,
    });
    // console.log(parsedFetch,id)
    await dispatch({
      type: backendTypes.Drag_Candidate,
      column: parsedFetch,
    });
  };
};

export const postComent = ({ id, data }) => {
  return (dispatch, getState) => {
    dispatch({
      type: backendTypes.POST_COMENTS,
      id,
      data,
    });
  };
};

export const Multiselect_Canditate = (data = {}) => {
  return (dispatch, getState) => {
    // TODO from_column = id columna de destinatario
    // to_column.docID = id columna de remitente
    const { array_candidate, id_Vacancy } = data;
    const { uid } = getState().auth;
    const { platform } = getState();
    const columns = getState().backend?.vacancy?.column;
    const candidates = getState().backend?.vacancy?.candidates;
    dispatch({
      type: backendTypes.Load,
      load: true,
    });
    if (array_candidate) {
      if (data.to_column === 'candidate') {
        // let New_array_candidate =[];
        // console.log(array_candidate)

        database
          .collection(`${platform.platformName}/data/companies`)
          .doc(uid)
          .collection('jobs')
          .doc(id_Vacancy)
          .collection('vacation_column')
          .doc(data.from_column)
          .get()
          .then((e) => {
            const temp = e.data();
            const from_array = temp.candidates;
            const lengthFrom = from_array ? from_array.length : [];
            if (lengthFrom <= 0) {
              Object.values(array_candidate).map((item, index) => {
                item.sortIndex = index;
              });

              database
                .collection(`${platform.platformName}/data/companies`)
                .doc(uid)
                .collection('jobs')
                .doc(id_Vacancy)
                .collection('vacation_column')
                .doc(data.from_column)
                .set(
                  {
                    candidates: array_candidate,
                  },
                  { merge: true }
                )
                .then(() => {
                  const column_temp = columns.find((e) => e.docID === data.from_column);
                  column_temp.candidates = array_candidate;
                  const arra_candidate_temp = [];
                  // console.log(candidates)
                  candidates.map((e) => {
                    const temp = array_candidate.find((o) => o.idUser === e.docID);
                    if (!temp) {
                      arra_candidate_temp.push(e);
                    }
                  });

                  dispatch({
                    type: backendTypes.Drag_Candidate_Organic,
                    column: columns,
                    candidates: arra_candidate_temp,
                  });
                  dispatch({
                    type: backendTypes.Column_CHECK_Candidate,
                    check_C: false,
                  });
                  dispatch(Post_Multi_Candidate([]));
                });
            } else {
              Object.values(array_candidate).map((item, index) => {
                from_array.push({
                  ...item,
                  sortIndex: index + lengthFrom,
                });
              });

              database
                .collection(`${platform.platformName}/data/companies`)
                .doc(uid)
                .collection('jobs')
                .doc(id_Vacancy)
                .collection('vacation_column')
                .doc(data.from_column)
                .set(
                  {
                    candidates: from_array,
                  },
                  { merge: true }
                )
                .then(() => {
                  const column_temp = columns.find((e) => e.docID === data.from_column);
                  column_temp.candidates = from_array;
                  const arra_candidate_temp = [];
                  // console.log(candidates)
                  candidates.map((e) => {
                    const temp = array_candidate.find((o) => o.idUser === e.docID);
                    if (!temp) {
                      arra_candidate_temp.push(e);
                    }
                  });
                  // console.log({
                  //     type: backendTypes.Drag_Candidate_Organic,
                  //     column: columns,
                  //     candidates: arra_candidate_temp
                  // })
                  dispatch({
                    type: backendTypes.Drag_Candidate_Organic,
                    column: columns,
                    candidates: arra_candidate_temp,
                  });
                  dispatch({
                    type: backendTypes.Column_CHECK_Candidate,
                    check_C: false,
                  });
                  dispatch(Post_Multi_Candidate([]));
                });
            }
          });
      } else if (data.from_column !== data.to_column.docID) {
        const array_candidates_to_column = data.to_column.candidates;
        const array_candidates_from_column = columns.find((e) => e.docID === data.from_column).candidates
          ? columns.find((e) => e.docID === data.from_column).candidates
          : [];
        // console.log(array_candidates_from_column, data.from_column)
        if (array_candidates_from_column.length <= 0) {
          Object.values(array_candidate).map((item, index) => {
            item.sortIndex = index;
          });

          const column_temp = columns.find((e) => e.docID === data.from_column);
          column_temp.candidates = array_candidate;
          database
            .collection(`${platform.platformName}/data/companies`)
            .doc(uid)
            .collection('jobs')
            .doc(id_Vacancy)
            .collection('vacation_column')
            .doc(data.from_column)
            .update({
              candidates: array_candidate,
            });

          const arra_candidate_temp_to = [];
          // console.log(candidates)
          array_candidates_to_column.map((e, index) => {
            const temp = array_candidate.find((o) => o.idUser === e.idUser);
            if (!temp) {
              arra_candidate_temp_to.push({ ...e });
            }
          });
          arra_candidate_temp_to.map((e, index) => {
            e.sortIndex = index;
          });

          const column_temp_to = columns.find((e) => e.docID === data.to_column.docID);
          column_temp_to.candidates = arra_candidate_temp_to;

          database
            .collection(`${platform.platformName}/data/companies`)
            .doc(uid)
            .collection('jobs')
            .doc(id_Vacancy)
            .collection('vacation_column')
            .doc(data.to_column.docID)
            .update({
              candidates: arra_candidate_temp_to,
            });
          dispatch({
            type: backendTypes.Drag_Candidate,
            column: columns,
          });
          dispatch(deleteColumn_Check());
          dispatch(Post_Multi_Candidate([]));
        } else {
          Object.values(array_candidate).map((item, index) => {
            array_candidates_from_column.push({
              ...item,
              sortIndex: index + array_candidates_from_column.length,
            });
          });

          const column_temp = columns.find((e) => e.docID === data.from_column);
          column_temp.candidates = array_candidates_from_column;
          database
            .collection(`${platform.platformName}/data/companies`)
            .doc(uid)
            .collection('jobs')
            .doc(id_Vacancy)
            .collection('vacation_column')
            .doc(data.from_column)
            .update({
              candidates: array_candidates_from_column,
            });

          const arra_candidate_temp_to = [];
          // console.log(candidates)
          array_candidates_to_column.map((e, index) => {
            const temp = array_candidate.find((o) => o.idUser === e.idUser);
            if (!temp) {
              arra_candidate_temp_to.push({ ...e });
            }
          });
          arra_candidate_temp_to.map((e, index) => {
            e.sortIndex = index;
          });

          const column_temp_to = columns.find((e) => e.docID === data.to_column.docID);
          column_temp_to.candidates = arra_candidate_temp_to;
          database
            .collection(`${platform.platformName}/data/companies`)
            .doc(uid)
            .collection('jobs')
            .doc(id_Vacancy)
            .collection('vacation_column')
            .doc(data.to_column.docID)
            .update({
              candidates: arra_candidate_temp_to,
            });
          dispatch({
            type: backendTypes.Drag_Candidate,
            column: columns,
          });
          dispatch(deleteColumn_Check());
          dispatch(Post_Multi_Candidate([]));
        }
      } else {
        NotificationManager.info('No se puede seleccionar la misma columna', '', 3000);
      }
    } else {
      NotificationManager.error('Seleccione al menos 1 candidato');
    }
  };
};
const Arrray_column_de = ['Filtro 1', 'Rechazados', 'Aceptado(s)'];
export const getColumn = ({ uid, id, parsedFetch }) => {
  return (dispatch, getState) => {
    const { platform } = getState();
    let candidates = getState().backend?.vacancy?.candidates.slice();
    dispatch({
      type: backendTypes.Load,
      load: true,
    });
    database
      .collection(`${platform.platformName}/data/companies`)
      .doc(uid)
      .collection('jobs')
      .doc(id)
      .collection('vacation_column')
      .get()
      .then((e) => {
        const columns_total = e.docs;
        if (columns_total.length <= 0) {
          // console.log('Crear las columnas');
          Arrray_column_de.map((name, index) => {
            database
              .collection(`${platform.platformName}/data/companies`)
              .doc(uid)
              .collection('jobs')
              .doc(id)
              .collection('vacation_column')
              .add({
                name,
                index,
              });
          });
        } else {
          const Array__column = [];
          columns_total.map((o) => {
            Array__column.push({
              ...o.data(),
              docID: o.id,
            });
            // console.log(o.data())
          });
          dispatch({
            type: backendTypes.VACANCY,
            column: Array__column.sort((a, b) => a.index - b.index),
          });
          Array__column.map((item, index) => {
            const _column_Candidate = item.candidates;
            if (_column_Candidate) {
              _column_Candidate.map((item_can, index) => {
                const decition = candidates.filter((e) => e.docID === item_can.idUser);
                if (decition.length > 0) {
                  candidates = candidates.filter((e) => e.docID !== item_can.idUser);
                }
              });
            }
          });
          dispatch({
            candidates,
            candidates_Store: parsedFetch,
            type: backendTypes.GET_DATA,
          });

          // console.log('Guardar las columnas que existen');
        }
      });
  };
};

export const getData = ({ uid, id }) => {
  return async (dispatch, getState) => {
    const { platform } = getState();
    dispatch({
      type: backendTypes.Load,
      load: true,
    });
    const connection = await database
      .collection(`${platform.platformName}/data/companies`)
      .doc(uid)
      .collection('jobs')
      .doc(id)
      .collection('applicants')
      .get();

    const parsedFetch = [];
    connection.docs.forEach((doc) => {
      const preparsed = doc.data();
      preparsed.docID = doc.id;
      parsedFetch.push(preparsed);
    });
    // console.log(parsedFetch)

    dispatch({
      candidates: parsedFetch,
      candidates_Store: parsedFetch,
      type: backendTypes.GET_DATA,
    });

    // dispatch(getColumn({uid, id}));

    if (parsedFetch.length === 0) {
      NotificationManager.info(`Todavía no hay candidatos que mostrar`, '', 3000);
    } else {
      NotificationManager.success(`Obtuvimos ${parsedFetch.length} candidatos`, '', 3000);
    }

    await dispatch(getColumn({ uid, id, parsedFetch }));
    // const connection2 = await database.collection(`companies/${uid}/jobs`).doc(id).get();
    // Acá se debe poner una redirección si esta vaci
    // dispatch({
    //     title: connection2.data().jobTitle,
    //     volumenVacancy: connection2.data().volumenVacancy,
    //     totalCandidates: connection2.data().totalCandidates,
    //     type: vacancyTypes.GET_TITLE_VACANCY
    // })
  };
};

export const Delete_Save_Candidate = (data, bd = false) => {
  return (dispatch, getState) => {
    const { uid } = getState().auth;
    const { platform } = getState();

    database
      .collection(`${platform.platformName}/data/companies`)
      .doc(uid)
      .collection('Save_Candidate')
      .doc(data)
      .delete()
      .then(() => {
        NotificationManager.success('Candidato eliminado de lista de de guardado', '', 3000);
        // if (bd) {
        //     const saveCanidates = getState().database.saveCanidates;
        //     const tmp = [];
        //     const user = [];
        //     Object.values(saveCanidates).map(e => {
        //         if (e.objectID !== data) {
        //             tmp.push(e)
        //         } else {
        //             delete e.save
        //             user.push(e)
        //             // dispatch(resetUserView(...user))
        //         }
        //     })
        // dispatch(deleteUser(tmp))
        // }
      })
      .catch((e) => {
        NotificationManager.error('Error con el servidor, intentelo más tarde', '', 3000);
      });
  };
};

// Candidatos Guardados
export const Save_Candidate = (data = {}) => {
  return (dispatch, getState) => {
    const uidData = getState().auth.claims.user_id;
    const { platform } = getState();
    const { uid } = getState().auth;
    const _vacancyOwner = getState().vacancy.id_Vacancy;
    const {
      cv,
      email,
      fileID,
      jobName,
      lastNames,
      longDescription,
      names,
      phoneNumber,
      stars,
      docID,
      vacancyOwner,
      base,
    } = data;
    const value_Save = {
      names,
      cv,
      email,
      fileID,
      jobName,
      lastNames,
      longDescription,
      userSaveID: uidData,
      candidateID: docID,
      time: moment().valueOf(),
      vacancyOwner: _vacancyOwner || vacancyOwner,
    };
    if (phoneNumber) {
      value_Save.phoneNumber = phoneNumber;
    }

    if (stars) {
      value_Save.stars = stars;
    }
    database
      .collection(`${platform.platformName}/data/companies`)
      .doc(uid)
      .collection('Save_Candidate')
      .add(value_Save)
      .then((e) => {
        NotificationManager.success('Candidato Guardado', '', 3000);
        // if (base) {
        //     database.collection(`${platform.platformName}/data/companies`)
        //         .doc(uid)
        //         .collection('Save_Candidate')
        //         .where('candidateID', '==', docID)
        //         .get()
        //         .then(e => {
        //             const _user = e.docs[0].data();
        //             _user.objectID = e.docs[0].id;
        //             _user.save = true;
        //             // dispatch(addUser(_user));
        //         })
        // }
      })
      .catch((e) => {
        // console.log(e)
        NotificationManager.error('Sucedio un problema con el servidor, intendelo más tarde', '', 3000);
      });
  };
};

export const Transfer_Candidate = (data = {}, candidate = {}) => {
  return (dispatch, getState) => {
    const { uid } = getState().auth;
    const { platform } = getState();
    const { jobTitle, jobID } = data;
    const { cv, email, fileID, lastNames, longDescription, names, phoneNumber, stars, docID } = candidate;
    const ValueF = {
      cv,
      email,
      fileID,
      type: 'Traspaso',
      jobName: jobTitle,
      lastNames,
      longDescription,
      names,
      time: moment().valueOf(),
      docID,
      Status_Paused: false,
    };
    if (phoneNumber) {
      ValueF.phoneNumber = phoneNumber;
    }

    database
      .collection(`${platform.platformName}/data/companies`)
      .doc(uid)
      .collection('jobs')
      .doc(jobID)
      .collection('applicants')
      .doc(docID)
      .get()
      .then((e) => {
        if (!e.exists) {
          // console.log(e)
          database
            .collection(`${platform.platformName}/data/companies`)
            .doc(uid)
            .collection('jobs')
            .doc(jobID)
            .collection('applicants')
            .doc(docID)
            .set(ValueF)
            .then(() => {
              NotificationManager.success('Candidato Transferido');
            })
            .catch((e) => {
              NotificationManager.success('Error en el servidor intentelo más tarde #5');
            });
        } else {
          NotificationManager.info('Este candidato ya fue transferido a esta vacante');
        }
      });
  };
};
